if (typeof boostPFSThemeConfig !== "undefined") {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      capitalizeFirstLetterFilterOptionValues: false,
      limit: boostPFSConfig.custom.products_per_page,
      loadProductFirst: false,
      numberFilterTree: 2,
      selectOptionContainer: ".grid__item .card-wrapper",
      stickyFixTopPos: true,
    },
    selector: {
      otpTopCartCount: ".cart-count-bubble",
    },
  };
}

(function () {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];

  BoostPFS.inject(this);
  /* For Filter Setting Layout */
  Selector.stickyElementDesktop =
    jQ(".boost-pfs-filter-left-col").length > 0 && !Utils.isMobile()
      ? ".boost-pfs-filter-left-col"
      : ".boost-pfs-filter-tree";
  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data["variants"][0];
    if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data["variants"].length; i++) {
        if (data["variants"][i].available) {
          firstVariant = data["variants"][i];
          break;
        }
      }
    }
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // want to get the following metafields, but I can't figure out how to get them now
    // assign quantity_min = product.metafields.custom.package_quantity.value | default: product.selected_or_first_available_variant.quantity_rule.min
    // assign quantity_step = product.metafields.custom.package_quantity.value | default: product.selected_or_first_available_variant.quantity_rule.increment

    const packageQuantity =
      data.metafields.find((m) => m.key === "package_quantity")?.value || 1;

    let inventory = true;
    if (!data.available) {
      inventory = false;
    }
    const firstVariant = data["variants"][0];
    if (firstVariant.inventory_quantity < packageQuantity) {
      inventory = false;
    }

    function toDecimalFix(v, decimalLength) {
      const n = Number(v);
      if (v === "" || isNaN(n)) {
        return v;
      }
      const ns = n.toString().split(".");
      if (ns.length === 1) {
        return n.toFixed(decimalLength);
      }
      const nDecimalLength = ns[1].length;
      if (nDecimalLength > decimalLength) {
        return n;
      }
      return n.toFixed(decimalLength);
    }

    const tags = [
      "P (Steel)",
      "M (Stainless)",
      "K (Cast Iron)",
      "N (Non-Ferrous)",
      "S (Heat-Resistant)",
      "H (Hard material)",
    ];
    const customMaterials = data.tags
      .filter((tag) => tags.includes(tag))
      .sort((a, b) => {
        const ao = tags.findIndex((m) => m === a) || 0;
        const bo = tags.findIndex((m) => m === b) || 0;
        return ao - bo;
      });
    const not_for_sale = data.metafields.find((m) => m.key === "not_for_sale")?.value || false;

    const edp =
      data.metafields.find((m) => m.key === "edp" || m.key === "EDP")?.value ||
      "";
    const drawingType =
      data.metafields.find((m) => m.key === "drawing_type")?.value || "";
    // const grade = data.metafields.find((m) => m.key === "grade")?.value || "";
    const cutting_diameter_metric =
      data.metafields.find((m) => m.key === "cutting_diameter_metric")?.value ||
      "";
    const cutting_diameter_inch =
      data.metafields.find((m) => m.key === "cutting_diameter_inch")?.value ||
      "";
    const L_D = data.metafields.find((m) => m.key === "L_D")?.value || "";
    const coolant =
      data.metafields.find((m) => m.key === "coolant")?.value || "";
    const max_depth_cut =
      data.metafields.find((m) => m.key === "max_depth_cut")?.value || "";
    const functional_length =
      data.metafields.find((m) => m.key === "functional_length")?.value || "";
    const connection_diameter_metric =
      data.metafields.find((m) => m.key === "connection_diameter_metric")
        ?.value || "";
    const connection_diameter_inch =
      data.metafields.find((m) => m.key === "connection_diameter_inch")
        ?.value || "";
    const tool_material =
      data.metafields.find((m) => m.key === "tool_material")?.value || "";
    const ZEFP = data.metafields.find((m) => m.key === "ZEFP")?.value || "";
    const ic_size_metric =
      data.metafields.find((m) => m.key === "ic_size_metric")?.value || "";
    const ic_size_inch =
      data.metafields.find((m) => m.key === "ic_size_inch")?.value || "";
    const corner_radius_metric =
      data.metafields.find((m) => m.key === "corner_radius_metric")?.value ||
      "";
    const corner_radius_inch =
      data.metafields.find((m) => m.key === "corner_radius_inch")?.value || "";
    const shankHeightMetric =
      data.metafields.find((m) => m.key === "shank_height_metric")?.value || "";
    const shankWidthMetric =
      data.metafields.find((m) => m.key === "shank_width_metric")?.value || "";
    const shankHeightInch =
      data.metafields.find((m) => m.key === "shank_height_inch")?.value || "";
    const shankWidthInch =
      data.metafields.find((m) => m.key === "shank_width_inch")?.value || "";
    const kapr = data.metafields.find((m) => m.key === "kapr")?.value || "";
    const groove_width_metric =
      data.metafields.find((m) => m.key === "groove_width_metric")?.value || "";
    const groove_width_inch =
      data.metafields.find((m) => m.key === "groove_width_inch")?.value || "";
    const cnc =
      data.metafields.find((m) => m.key === "num_corner")?.value || "";
    const num_teeth =
      data.metafields.find((m) => m.key === "num_teeth")?.value || "";
    const cut_edge_length_metric =
      data.metafields.find((m) => m.key === "cut_edge_length_metric")?.value ||
      "";
    const cut_edge_length_inch =
      data.metafields.find((m) => m.key === "cut_edge_length_inch")?.value ||
      "";
    const breaker =
      data.metafields.find((m) => m.key === "breaker")?.value || "";
    const hand = data.metafields.find((m) => m.key === "hand")?.value || "";
    const ansi = data.metafields.find((m) => m.key === "ansi")?.value || "";

    // const shankHeight = shankHeightMetric
    //   ? `${shankHeightMetric}mm`
    //   : shankHeightInch
    //   ? `${shankHeightInch}inch`
    //   : "";
    // const shankWidth = shankWidthMetric
    //   ? `${shankWidthMetric}mm`
    //   : shankWidthInch
    //   ? `${shankWidthInch}inch`
    //   : "";

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : "";
    var saleClass = onSale ? boostPFSTemplate.saleClass : "";
    var ratioImage = getRatioImage(data);
    var imageAspectRatio =
      (ratioImage / getAspectRatio(data.images_info[0])) * 100;

    itemHtml = itemHtml.replace(/{{imageAspectRatio}}/g, imageAspectRatio);

    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add Card product class
    itemHtml = itemHtml.replace(
      /{{cardProductClass}}/g,
      buildCardProductClass(data)
    );
    // Add Card inner product class
    itemHtml = itemHtml.replace(
      /{{cardInnerProductClass}}/g,
      buildCardInnerProductClass(data)
    );
    // Add Card badge position
    itemHtml = itemHtml.replace(
      /{{cardBadgePosition}}/g,
      boostPFSThemeConfig.custom.badge_position
    );
    // Add check card heading five
    itemHtml = itemHtml.replace(
      /{{cardIsHeadingFive}}/g,
      buildCardIsHeadingFive(data)
    );

    const price = Utils.formatMoney(data.price_min);
    if (not_for_sale === true || String(not_for_sale).toLowerCase() === "true") {
      // Add sold out Label
      itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, "");
      // Add sale Label
      itemHtml = itemHtml.replace(/{{itemSale}}/g, "");
      // Add Images
      itemHtml = itemHtml.replace(/{{itemImages}}/g, "");
      // Add Price
      itemHtml = itemHtml.replace(/{{itemPrice}}/g, "");
      itemHtml = itemHtml.replace(/{{customItemPrice}}/g, "");

      itemHtml = itemHtml.replace(/stsCustomHasInventory/g, "none");
      itemHtml = itemHtml.replace(/stsCustomNoInventory/g, "none");
      itemHtml = itemHtml.replace(
        /{{customPackageQuantity}}/g,
        packageQuantity
      );
    } else {
      // Add sold out Label
      itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
      // Add sale Label
      itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
      // Add Images
      itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
      // Add Price
      itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
      itemHtml = itemHtml.replace(/{{customItemPrice}}/g, price);

      itemHtml = itemHtml.replace(
        /stsCustomHasInventory/g,
        inventory ? "inline-block" : "none"
      );
      itemHtml = itemHtml.replace(
        /stsCustomNoInventoryInlineBlock/g,
        inventory ? "none" : "inline-block"
      );
      itemHtml = itemHtml.replace(
        /stsCustomNoInventory/g,
        inventory ? "none" : "flex"
      );
      itemHtml = itemHtml.replace(
        /{{customPackageQuantity}}/g,
        packageQuantity
      );
    }

    // Add Review
    if (
      typeof Integration === "undefined" ||
      (typeof Integration != "undefined" &&
        typeof Integration.hascompileTemplate == "function" &&
        !Integration.hascompileTemplate("reviews"))
    ) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
    }

    // Add Description
    itemHtml = itemHtml.replace(
      /{{itemDescription}}/g,
      boostPFSThemeConfig.custom.description || ""
    );

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildProductItemUrlWithVariant(data)
    );

    // sts-customize
    if (images[0]) {
      itemHtml = itemHtml.replace(
        /{{customItemImages}}/g,
        `<img src="${images[0].src}" width="85px" height="63px" alt="${data.title} image" />`
      );
    } else {
      itemHtml = itemHtml.replace(/{{customItemImages}}/g, "");
    }
    itemHtml = itemHtml.replace(
      /{{itemTitleBr}}/g,
      data.title.replace(/ /g, "<br>")
    );
    itemHtml = itemHtml.replace(/{{customProductId}}/g, data.variants[0].id);
    itemHtml = itemHtml.replace(/{{customEDP}}/g, edp);
    itemHtml = itemHtml.replace(/{{customDrawingType}}/g, drawingType);
    // itemHtml = itemHtml.replace(/{{customGrade}}/g, grade);

    itemHtml = itemHtml.replace(
      /{{customDCmm}}/g,
      toDecimalFix(cutting_diameter_metric, 1)
    );
    itemHtml = itemHtml.replace(
      /{{customDCinch}}/g,
      toDecimalFix(cutting_diameter_inch, 4)
    );
    itemHtml = itemHtml.replace(/{{customLD}}/g, L_D);
    itemHtml = itemHtml.replace(/{{customCoolant}}/g, coolant);
    itemHtml = itemHtml.replace(/{{customMaxDepthCut}}/g, max_depth_cut);
    itemHtml = itemHtml.replace(
      /{{customFunctionalLength}}/g,
      functional_length
    );
    itemHtml = itemHtml.replace(
      /{{customConnectionDiameterMetric}}/g,
      toDecimalFix(connection_diameter_metric, 1)
    );
    itemHtml = itemHtml.replace(
      /{{customConnectionDiameterInch}}/g,
      toDecimalFix(connection_diameter_inch, 4)
    );
    itemHtml = itemHtml.replace(/{{customToolMaterials}}/g, tool_material);
    itemHtml = itemHtml.replace(/{{customZEFP}}/g, ZEFP);
    itemHtml = itemHtml.replace(
      /{{customICSizeMetric}}/g,
      toDecimalFix(ic_size_metric, 1)
    );
    itemHtml = itemHtml.replace(
      /{{customICSizeInch}}/g,
      toDecimalFix(ic_size_inch, 4)
    );
    itemHtml = itemHtml.replace(
      /{{customGrooveWidthMm}}/g,
      toDecimalFix(groove_width_metric, 1)
    );
    itemHtml = itemHtml.replace(
      /{{customGrooveWidthInch}}/g,
      toDecimalFix(groove_width_inch, 4)
    );
    itemHtml = itemHtml.replace(
      /{{customCornerRadiusMetric}}/g,
      toDecimalFix(corner_radius_metric, 1)
    );
    itemHtml = itemHtml.replace(
      /{{customCornerRadiusInch}}/g,
      toDecimalFix(corner_radius_inch, 4)
    );

    // const tags = [
    //   "P (Steel)",
    //   "M (Stainless)",
    //   "K (Cast Iron)",
    //   "N (Non-Ferrous)",
    //   "S (Heat-Resistant)",
    //   "H (Hard material)",
    // ];
    if (customMaterials.includes("P (Steel)")) {
      itemHtml = itemHtml.replace(/__customP__/g, "show");
    } else {
      itemHtml = itemHtml.replace(/__customP__/g, "");
    }
    if (customMaterials.includes("M (Stainless)")) {
      itemHtml = itemHtml.replace(/__customM__/g, "show");
    } else {
      itemHtml = itemHtml.replace(/__customM__/g, "");
    }
    if (customMaterials.includes("K (Cast Iron)")) {
      itemHtml = itemHtml.replace(/__customK__/g, "show");
    } else {
      itemHtml = itemHtml.replace(/__customK__/g, "");
    }
    if (customMaterials.includes("N (Non-Ferrous)")) {
      itemHtml = itemHtml.replace(/__customN__/g, "show");
    } else {
      itemHtml = itemHtml.replace(/__customN__/g, "");
    }
    if (customMaterials.includes("S (Heat-Resistant)")) {
      itemHtml = itemHtml.replace(/__customS__/g, "show");
    } else {
      itemHtml = itemHtml.replace(/__customS__/g, "");
    }
    if (customMaterials.includes("H (Hard material)")) {
      itemHtml = itemHtml.replace(/__customH__/g, "show");
    } else {
      itemHtml = itemHtml.replace(/__customH__/g, "");
    }

    itemHtml = itemHtml.replace(
      /{{customShankHeightMetric}}/g,
      toDecimalFix(shankHeightMetric, 1)
    );
    itemHtml = itemHtml.replace(
      /{{customShankHeightInch}}/g,
      toDecimalFix(shankHeightInch, 4)
    );
    itemHtml = itemHtml.replace(
      /{{customShankWidthMetric}}/g,
      toDecimalFix(shankWidthMetric, 1)
    );
    itemHtml = itemHtml.replace(
      /{{customShankWidthInch}}/g,
      toDecimalFix(shankWidthInch, 4)
    );
    itemHtml = itemHtml.replace(/{{customKapr}}/g, kapr);
    itemHtml = itemHtml.replace(/{{customCNC}}/g, cnc);
    itemHtml = itemHtml.replace(/{{customNumTeeth}}/g, num_teeth);
    itemHtml = itemHtml.replace(
      /{{customCutEdgeLengthMetric}}/g,
      toDecimalFix(cut_edge_length_metric, 1)
    );
    itemHtml = itemHtml.replace(
      /{{customCutEdgeLengthInch}}/g,
      toDecimalFix(cut_edge_length_inch, 4)
    );
    itemHtml = itemHtml.replace(/{{customBreaker}}/g, breaker);
    itemHtml = itemHtml.replace(/{{customHand}}/g, hand);
    itemHtml = itemHtml.replace(/{{customAnsi}}/g, ansi);
    itemHtml = itemHtml.replace(
      /{{customAnsiBr}}/g,
      ansi.replace(/ /g, "<br>")
    );

    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildImages(data) {
    var html = "";
    if (images && Array.isArray(images) && images.length > 0) {
      html += '<div class="card__media">';
      var aspectRatio = "",
        rangeWidths = boostPFSRangeWidths;

      var dataSrcSet = "",
        imgAlt = data.title,
        flipImageSrcSet = "";

      var activeSwapImage =
        !Utils.isMobile() &&
        images.length > 1 &&
        boostPFSThemeConfig.custom.hasOwnProperty("show_secondary_image") &&
        boostPFSThemeConfig.custom.show_secondary_image == true;

      for (var i = 0; i < rangeWidths.length; i++) {
        dataSrcSet +=
          Utils.getFeaturedImage(images, rangeWidths[i] + "x") +
          " " +
          rangeWidths[i] +
          "w";

        if (activeSwapImage) {
          flipImageSrcSet +=
            Utils.optimizeImage(images[1]["src"], rangeWidths[i] + "x") +
            " " +
            rangeWidths[i] +
            "w";
        }

        if (i < rangeWidths.length - 1) {
          dataSrcSet += ", ";

          if (activeSwapImage) {
            flipImageSrcSet += ", ";
          }
        }
      }

      aspectRatio = images[0]["width"] / images[0]["height"];
      html +=
        '<div class="media media--transparent media--hover-effect"><img class="motion-reduce"' +
        'loading="lazy"' +
        'srcset="' +
        dataSrcSet +
        '" ' +
        'height="' +
        images[0].height +
        '" ' +
        'width="' +
        images[0].width +
        '" ' +
        'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"' +
        'src="' +
        Utils.optimizeImage(images[0].src, "533x") +
        '" ' +
        'alt="' +
        imgAlt +
        '" />';

      if (activeSwapImage) {
        html +=
          '<img class="motion-reduce"' +
          'loading="lazy"' +
          'srcset="' +
          flipImageSrcSet +
          '" ' +
          'height="' +
          images[1].height +
          '" ' +
          'width="' +
          images[1].width +
          '" ' +
          'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"' +
          'src="' +
          Utils.optimizeImage(images[1].src, "533x") +
          '" ' +
          'alt="' +
          imgAlt +
          '" />';
      }
      html += "</div>";
      html += "</div>";
    } else {
      html += `<div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading">
                    <a href="#" class="full-unstyled-link">
                      ${data.title}
                    </a>
                  </h3>
                </div>
              </div>`;
    }
    return html;
  }

  function buildCardProductClass(data) {
    var html = "" + boostPFSThemeConfig.custom.card_style;
    if (!images) {
      html += " card--text";
    } else {
      html += " card--media";
    }
    if (boostPFSThemeConfig.custom.card_style == "card") {
      html += " color-" + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (!images && boostPFSThemeConfig.custom.card_style == "card") {
      html += " ratio";
    }
    return html;
  }

  function buildCardInnerProductClass(data) {
    var html = "";
    if (boostPFSThemeConfig.custom.card_style == "standard") {
      html += " color-" + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (images || boostPFSThemeConfig.custom.card_style == "standard") {
      html += " ratio";
    }
    return html;
  }

  function buildCardIsHeadingFive(data) {
    var html = "";
    if (images || boostPFSThemeConfig.custom.card_style == "standard") {
      html = "h5";
    }
    return html;
  }

  function buildVendor(data) {
    var html = "";
    if (
      boostPFSThemeConfig.custom.hasOwnProperty("show_vendor") &&
      boostPFSThemeConfig.custom.show_vendor === true
    ) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }

  function buildPrice(data) {
    var html = "";
    var noComparePrice =
      data.price_varies === false && data.compare_at_price_varies;
    var priceAmount = boostPFSConfig.custom.currency_code_enabled
      ? Utils.formatMoney(data.price_min, "money_with_currency")
      : Utils.formatMoney(data.price_min);
    var compareAtPrice = boostPFSConfig.custom.currency_code_enabled
      ? Utils.formatMoney(data.compare_at_price_min, "money_with_currency")
      : Utils.formatMoney(data.compare_at_price_min);
    var moneyPrice = priceVaries
      ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount)
      : priceAmount;
    var unitPriceClass =
      !data.available ||
      typeof data?.selected_or_first_available_variant
        ?.unit_price_measurement === "undefined"
        ? "hidden"
        : "";
    html = `<div class="price sts-country-sealed ${
      soldOut ? "price--sold-out" : ""
    } ${onSale ? "price--on-sale" : ""}${
      noComparePrice ? "price--no-compare" : ""
    }">
          <div class="price__container">
            <div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span class="price-item price-item--regular">
                ${moneyPrice}
              </span>
            </div>
            <div class="price__sale">
              <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span>
                <s class="price-item price-item--regular">
                  ${compareAtPrice}
                </s>
              </span>
              <span class="visually-hidden visually-hidden--inline">${
                boostPFSConfig.label.sale_price
              }</span>
              <span class="price-item price-item--sale price-item--last">
                ${moneyPrice}
              </span>
            </div>
            <small class="unit-price caption ${unitPriceClass}">
              <span class="visually-hidden">${
                boostPFSConfig.label.unit_price
              }</span>
              <span class="price-item price-item--last">
                <span>${Utils.formatMoney(
                  data.selected_or_first_available_variant &&
                    data.selected_or_first_available_variant.unit_price
                )}</span>
                <span aria-hidden="true">/</span>
                <span class="visually-hidden">&nbsp;${
                  boostPFSConfig.label.unit_price_separator
                }&nbsp;</span>
              </span>
            </small>
          </div>
        </div>`;
    return html;
  }

  function buildSoldOutLabel() {
    // Build Sold out label
    var soldOutLabel = "";
    if (
      boostPFSThemeConfig.custom.hasOwnProperty(
        "sold_out_badge_color_scheme"
      ) &&
      soldOut
    ) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(
        /{{soldOutBadgeClass}}/g,
        boostPFSThemeConfig.custom.sold_out_badge_color_scheme
      );
    }
    return soldOutLabel;
  }

  function buildSaleLabel() {
    // Build Sale label
    var saleLabel = "";
    if (
      boostPFSThemeConfig.custom.hasOwnProperty("sale_badge_color_scheme") &&
      onSale &&
      !soldOut
    ) {
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(
        /{{saleBadgeClass}}/g,
        boostPFSThemeConfig.custom.sale_badge_color_scheme
      );
    }
    return saleLabel;
  }

  function buildReview(data) {
    var html = "";
    if (
      boostPFSThemeConfig.custom.hasOwnProperty("show_product_review") &&
      boostPFSThemeConfig.custom.show_product_review == true &&
      Utils.getProductMetafield(data, "reviews", "rating") !== null
    ) {
      var ratingObj = JSON.parse(
        Utils.getProductMetafield(data, "reviews", "rating")
      );
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >= 0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info
        .replace("{{ rating_value }}", ratingObj.value)
        .replace("{{ rating_max }}", ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${
                  boostPFSConfig.custom.accent_icons
                }" style="--rating: ${Math.round(
        ratingObj.value.rating
      )}; --rating-max: ${
        ratingObj.value.scale_max
      }; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${
        ratingObj.value.scale_max
      }</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(
                  data,
                  "reviews",
                  "rating_count"
                )})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(
                  data,
                  "reviews",
                  "rating_count"
                )} ${boostPFSConfig.label.total_reviews}</span>
              </p>`;
    }
    return html;
  }

  function getAspectRatio(data) {
    var width = data == null ? "535" : data.width;
    var height = data == null ? "535" : data.height;

    return width / height;
  }

  function getRatioImage(data) {
    var ratio = 1;
    if (images && boostPFSThemeConfig.custom.media_size == "portrait") {
      ratio = 0.8;
    } else if (images && boostPFSThemeConfig.custom.media_size == "adapt") {
      ratio = getAspectRatio(data.images[0]);
    }
    if (ratio === 0 || ratio === null) {
      ratio = 1;
    }
    return ratio;
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return "";
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml =
      currentPage > 1 ? boostPFSTemplate.previousActiveHtml : "";
    previousHtml = previousHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink("page", currentPage, currentPage - 1)
    );
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml =
      currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : "";
    nextHtml = nextHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink("page", currentPage, currentPage + 1)
    );
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (
      var iBefore = currentPage - 1;
      iBefore > currentPage - 3 && iBefore > 0;
      iBefore--
    ) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift("...");
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (
      var iAfter = currentPage + 1;
      iAfter < currentPage + 3 && iAfter <= totalPage;
      iAfter++
    ) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push("...");
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = "";
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == "...") {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml +=
          pageArr[iPage] == currentPage
            ? boostPFSTemplate.pageItemSelectedHtml
            : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, pageArr[iPage])
      );
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = "";
    if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || "";
        // Build content
        var sortingItemsHtml = "";
        for (var k in sortingArr) {
          var isSelected = "";
          if (paramSort == k) {
            isSelected = 'selected="selected"';
          }
          sortingItemsHtml +=
            '<option value="' +
            k +
            '"' +
            isSelected +
            ">" +
            sortingArr[k] +
            "</option>";
        }
        html = boostPFSTemplate.sortingHtml.replace(
          /{{sortingItems}}/g,
          sortingItemsHtml
        );
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function () {
    jQ(Selector.topSorting).html(this.compileTemplate());

    if (
      jQ(".boost-pfs-filter-custom-sorting").hasClass(
        "boost-pfs-filter-sort-active"
      )
    ) {
      jQ(".boost-pfs-filter-custom-sorting").toggleClass(
        "boost-pfs-filter-sort-active"
      );
    }

    var labelSort = "";
    var paramSort = Globals.queryParams.sort || "";
    var sortingList = Utils.getSortingList();
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort];
    } else {
      labelSort = Labels.sorting;
    }

    jQ(".boost-pfs-filter-custom-sorting button span span").text(labelSort);
  };

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    jQ(Selector.topSorting + " .facet-filters__sort").change(function (e) {
      e.preventDefault();
      FilterApi.setParam("sort", jQ(this).val());
      FilterApi.setParam("page", 1);
      FilterApi.applyFilter("sort");
    });
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;
  };

  // Build Additional Elements
  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    jQ(".boost-pfs-filter-total-product").html(
      data.total_product + " products"
    );
  };

  FilterOptionItem.prototype.beforeRender = function () {
    this.label = this.label.replace(/Mm/g, "mm");
  };

  FilterOption.prototype.afterRender = function () {
    // if (this.filterOptionId == "pf_m_::custom::unit") {
    //   const elm = jQ(this.$filterItemsContainerElement).find("li:nth-child(2)");
    //   elm.addClass("clicked");
    //   setTimeout(() => {
    //     if (
    //       Utils.isSearchPage() &&
    //       !Globals.queryParams.hasOwnProperty("pf_m_::custom::unit")
    //     )
    //       document
    //         .querySelector(".boost-pfs-filter-option-label.clicked")
    //         .click();
    //   }, 500);
    // }
    // sts-customize, this needs input.id = custom_parent_lv3_collections
    if (this.filterOptionId == "pf_t_tag") {
      const selected = [];
      const lv3Handles = document
        .getElementById("custom_parent_lv3_collections")
        ?.value?.split(",");
      if (lv3Handles && lv3Handles.length > 0) {
        this.filterItems.forEach((obj, key) => {
          if (obj.isSelected) {
            selected.push(key.replace("collection_", ""));
          }
        });
        const unselectedlv3Handles = lv3Handles.filter(
          (h) => !selected.includes(h)
        );
        if (lv3Handles.length !== unselectedlv3Handles.length) {
          const replaceCss = unselectedlv3Handles
            .map((h) => h.replace("-", "_"))
            .map(
              (h) =>
                `.custom-product-grid table thead th.${h}, .custom-product-grid table tbody td.${h} { display: none }`
            );
          if (
            lv3Handles.includes("milling-inserts") &&
            lv3Handles.includes("milling-tools")
          ) {
            const key = "number_of_cutting_edge";
            replaceCss.push(
              `.custom-product-grid table thead th.${key}, .custom-product-grid table tbody td.${key} { display: table-cell }`
            );
          }
          if (
            lv3Handles.includes("grooving-inserts") &&
            lv3Handles.includes("threading-tools")
          ) {
            const key = "corner_radius";
            replaceCss.push(
              `.custom-product-grid table thead th.${key}, .custom-product-grid table tbody td.${key} { display: table-cell }`
            );
          }
          if (
            lv3Handles.includes("grooving-inserts") &&
            lv3Handles.includes("grooving-tools")
          ) {
            const key = "cutting_width";
            replaceCss.push(
              `.custom-product-grid table thead th.${key}, .custom-product-grid table tbody td.${key} { display: table-cell }`
            );
          }
          const sheet = new CSSStyleSheet();
          sheet.replaceSync(replaceCss.join(" "));
          document.adoptedStyleSheets = [sheet];
        }
      }
    }

    // sts-customize, call function to show sealed items in header.liquid
    // Pick one filter to run only once
    if (this.filterOptionId == "pf_m_::custom::unit") {
      showSealedItems && showSealedItems();
    }
  };

  /************************** END BUILD TOOLBAR **************************/
})();
